import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular/src/interfaces';
import { T2LoadingService } from 'app/trip2-theme/components/t2-loading/t2-loading.service';
import { PayrollsService } from 'app/pages/payrolls/payrolls.service';
import { _downloadFile } from 'app/utils/trip2-query-builder/utils/helpers';
import { ReservationService } from 'app/pages/trip-reservations/reservations.service';
import { ToastrAlertHelper } from 'app/core/helpers/toastr-alert-helper-service';

@Component({
  selector: 'app-claim-button',
  templateUrl: './claim-button.component.html',
  styleUrls: ['./claim-button.component.scss']
})
export class ClaimButtonComponent implements ICellRendererAngularComp {

  public params: any;

  constructor(
    private loading: T2LoadingService,
    private service: ReservationService,
    private toastrAlertHelper: ToastrAlertHelper,
  ) { }

  agInit(params: any): void {
    this.params = params;
  }

  public invokeParentMethod() {
    this.loading.show();
      const providerclaimtripid = this.params.data.providerclaimtripid;
      this.service.getRepotClaim(providerclaimtripid)
      .finally(() => {
        this.loading.hiden();
      })
      .subscribe(
        (success) => {
          if (success.status === 200) {
             const name = 'claim-'+ this.params.data.providerclaimtripid +'.pdf';
            _downloadFile(success.blob(), name);
          } else {
            this.toastrAlertHelper.error(success.statusText);
          }
        },
        (error) => {
          this.toastrAlertHelper.error(error.statusText);
        }
      );
  }

  refresh(): boolean {
    return false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/grid-components/claim-button/claim-button.component.ts